import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import tw, { css, styled } from 'twin.macro'
import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import useProduct from '../../hooks/useProduct'
import useWindowResize from '../../hooks/useWindowResize'
const windowGlobal = typeof window !== 'undefined' && window
import {
	ItemSummaryContainer,
	ItemDetailsContainer,
	ItemTitle,
	ItemDetails,
	ItemImage,
	VideoContainer,
	ThumbnailsContainer,
	ThumbContainer,
	Thumbs,
	SvgContainer,
	StyledSvg,
	SummaryCtaContainer,
	SummaryButton,
	Book,
	Novideo,
	HyperLinkText,
	Bold,
	Italic,
	UnderlinedText,
} from './styles'

const options = {
	renderMark: {
		[MARKS.BOLD]: text => <Bold>{text}</Bold>,
		[MARKS.ITALIC]: text => <Italic>{text}</Italic>,
		[MARKS.UNDERLINE]: text => <UnderlinedText>{text}</UnderlinedText>,
	},
	renderNode: {
		[BLOCKS.HEADING_2]: (node, children) => <ItemTitle>{children}</ItemTitle>,
		[BLOCKS.PARAGRAPH]: (node, children) => (
			<ItemDetails>{children}</ItemDetails>
		),
		[BLOCKS.EMBEDDED_ASSET]: node => {
			const asset = node.data && node.data.target && node.data.target.fields
			if (asset === undefined) return // nothing
			const { file, description } = asset
			if (/for life/i.test(description['en-AU'])) {
				return (
					<Link to="/forlife">
						<ItemImage
							src={file['en-AU'].url}
							alt={description['en-AU']}
							loading="lazy"
						/>
					</Link>
				)
			}
			return (
				<ItemImage
					src={file['en-AU'].url}
					alt={description['en-AU']}
					loading="lazy"
				/>
			)
		},
		[INLINES.HYPERLINK]: (node, children) => {
			const text = node.content[0].value
			return (
				<HyperLinkText href={node.data.uri} target="_blank">
					{text}
				</HyperLinkText>
			)
		},
	},
}

const ItemSummary = ({
	content,
	vid,
	brand,
	tags,
	brandPage,
	title,
	comparisonitem,
	active,
	series,
	model,
	categories,
	checkedLocale,
	locale,
}) => {
	const comparison =
		comparisonitem === null ? true : comparisonitem ? true : false
	const isZaEnquireProduct =
		locale === 'en-ZA' &&
		(brand === 'EcoSwim' ||
			brand === 'Eco Swim' ||
			brand === 'Mineral Swim' ||
			series === 'Eco Swim' ||
			series === 'Mineral Swim' ||
			(brandPage && (brandPage.slug === 'ecoswim' || brandPage.slug === 'mineral-swim')))
	const [currentVid, setCurrentVid] = useState(vid != null ? vid[0] : vid)

	const [...thumbs] = vid != null ? vid : []
	let filteredThumbs = thumbs.filter(x => {
		return x != currentVid
	})

	const commercialCheck = tags.includes('commercial')
	const residentialCheck = tags.includes('residential')
	const tagCheck = commercialCheck
		? 'commercial'
		: residentialCheck
		? 'residential'
		: ''

	const { addToTable } = useProduct()
	const { height, width } = useWindowResize()
	const checkLength = (key, e, brandPage, tagCheck, title) => {
		const items = windowGlobal.sessionStorage.getItem(key)
		const parsedItems = JSON.parse(items)
		if (width > 1023) {
			if (parsedItems.length >= 3) {
				e.preventDefault()
				if (
					windowGlobal.confirm(`Items to compare cannot be more than 3.
Clicking OK will redirect you to the product comparison page.`)
				) {
					window.location.href = `/product-comparison#${key}`
				}
			} else {
				addToTable(brandPage, tagCheck, title)
			}
		} else {
			if (parsedItems.length >= 2) {
				e.preventDefault()
				if (
					windowGlobal.confirm(`Items to compare cannot be more than 2.
Clicking OK will redirect you to the product comparison page.`)
				) {
					window.location.href = `/product-comparison#${key}`
				}
			} else {
				addToTable(brandPage, tagCheck, title)
			}
		}
	}

	const getCountry = locale.split('-')[1].toLowerCase()
	const array = ["spare-parts", "pool-equipment"]
	return (
		<ItemSummaryContainer>
			<ItemDetailsContainer>
				{content
					? documentToReactComponents(content.json, options)
					: 'No description yet for this product'}
				{categories === null ? (
					<SummaryCtaContainer>
						<Book
							css={tw`ml-0`}
							className="alt"
							onClick={() => {}}
							onKeyDown={() => {}}
							to={
								isZaEnquireProduct
									? 'https://www.maytronics.com.au/support/contact/'
									: active === null || active === true
									? brand != 'Dolphin'
										? `${checkedLocale}/support/contact/?subject=${encodeURIComponent(
												title.toLowerCase()
										  )}#contact-form`
										: series === 'Wave'
										? `${checkedLocale}/support/contact/?subject=commercial+trial+${encodeURIComponent(
												model.toLowerCase()
										  )}#contact-form`
										: `${checkedLocale}/book-a-demo`
									: series != 'Wave'
									? `${checkedLocale}/support/contact/?subject=${encodeURIComponent(
											title.toLowerCase()
									  )}#contact-form`
									: `${checkedLocale}/support/contact/?subject=commercial+trial+${encodeURIComponent(
											model.toLowerCase()
									  )}#contact-form`
							}
						>
							{active === null || active === true
								? brand != 'Dolphin'
									? isZaEnquireProduct
										? 'Enquire Now'
										: 'Get a Quote'
									: series === 'Wave'
									? locale === 'en-AU'
										? 'Request a Trial'
										: 'Enquire now'
									: 'Book a Demo'
								: series === 'Wave'
								? 'Request a Trial'
								: 'Enquire Now'}
						</Book>
						{!isZaEnquireProduct && (
							<SummaryButton
								href={
									comparison
										? `${checkedLocale}/product-comparison#${
												brandPage.slug === 'dolphin' ? tagCheck : brandPage.slug
										  }`
										: '#'
								}
								className="alt"
								onClick={e => {
									comparison
										? checkLength(
												brandPage.slug === 'dolphin' ? tagCheck : brandPage.slug,
												e,
												brandPage.slug,
												tagCheck,
												title
										  )
										: ''
								}}
							>
								Compare
							</SummaryButton>
						)}
					</SummaryCtaContainer>
				) : array.includes(!categories.slug) ? (
					<SummaryCtaContainer>
						<Book
							css={tw`ml-0`}
							className="alt"
							onClick={() => {}}
							onKeyDown={() => {}}
							to={
								isZaEnquireProduct
									? 'https://www.maytronics.com.au/support/contact/'
									: active === null || active === true
									? brand != 'Dolphin'
										? `${checkedLocale}/support/contact/?subject=${encodeURIComponent(
												title.toLowerCase()
										  )}#contact-form`
										: series === 'Wave'
										? `${checkedLocale}/support/contact/?subject=commercial+trial+${encodeURIComponent(
												model.toLowerCase()
										  )}#contact-form`
										: `${checkedLocale}/book-a-demo`
									: series != 'Wave'
									? locale === 'en-AU' || series === 'E Line' || isZaEnquireProduct
										? `${checkedLocale}/support/contact/?subject=${encodeURIComponent(
												title.toLowerCase()
										  )}#contact-form`
										: `https://mydolphin.co.${getCountry}`
									: `${checkedLocale}/support/contact/?subject=commercial+trial+${encodeURIComponent(
											model.toLowerCase()
									  )}#contact-form`
							}
						>
							{active === null || active === true
								? brand != 'Dolphin'
									? isZaEnquireProduct
										? 'Enquire Now'
										: 'Get a Quote'
									: series === 'Wave'
									? 'Request a Trial'
									: 'Book a Demo'
								: series === 'Wave'
								? locale === 'en-AU'
									? 'Request a Trial'
									: 'Enquire now'
								: locale === 'en-AU' || series === 'E Line' || isZaEnquireProduct
								? 'Enquire Now'
								: 'Buy at MyDolphin'}
						</Book>
						{!isZaEnquireProduct && (
							<SummaryButton
								href={
									comparison
										? `${checkedLocale}/product-comparison#${
												brandPage.slug === 'dolphin' ? tagCheck : brandPage.slug
										  }`
										: '#'
								}
								className="alt"
								onClick={e => {
									comparison
										? checkLength(
												brandPage.slug === 'dolphin' ? tagCheck : brandPage.slug,
												e,
												brandPage.slug,
												tagCheck,
												title
										  )
										: ''
								}}
							>
								Compare
							</SummaryButton>
						)}
					</SummaryCtaContainer>
				) : (
					''
				)}
			</ItemDetailsContainer>
			{currentVid != null && (
				<VideoContainer>
					<iframe
						width="100%"
						height="100%"
						src={`https://www.youtube.com/embed/${currentVid}`}
						allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
						loading="lazy"
					></iframe>
					{filteredThumbs.length > 0 && (
						<ThumbnailsContainer>
							{filteredThumbs.map((thumb, i) => {
								return (
									<ThumbContainer key={i}>
										<Thumbs
											src={`https://img.youtube.com/vi/${thumb}/mqdefault.jpg`}
											key={i}
											loading="lazy"
										></Thumbs>
										<SvgContainer
											onClick={() => {
												setCurrentVid(thumb)
											}}
										>
											<StyledSvg width="60px" height="60px" color="#fff" />
										</SvgContainer>
									</ThumbContainer>
								)
							})}
						</ThumbnailsContainer>
					)}
				</VideoContainer>
			)}
		</ItemSummaryContainer>
	)
}
export default ItemSummary
